import { initialState } from "../constants";

const sliceHandler = ({ name, action, success, failure, reset }: any) => ({
    name,
    initialState,
    reducers: {
        [action]: (state: any) => {
            state.isLoading = true;
        },
        [success]: (state: any, action: any) => {
            state.isLoading = false;
            state.data = action.payload;
        },
        [failure]: (state: any, action: any) => {
            state.isLoading = false;
            state.data = action.payload;
        },
        [reset]: (state: any) => {
            state.isLoading = false;
            state.data = null;
        },
    },
})

export { sliceHandler };